<template>
    <div>
        <div class="nav-tabs-container pt-1" v-if="!hideTabs">
            <div class="nav-tabs-scroll-helper">
                <ul class="nav nav-tabs">

                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': mode == 'all'}" href id="tabLinkEarnings1" role="tab" aria-controls="tabContentEarnings1" :aria-selected="mode == 'all'" @click.prevent="mode = 'all'; $bus.$emit('resize')">
                            All Earnings ({{ allEarningsCount }})
                        </a>
                    </li>

                    <li class="nav-item">
                        <a class="nav-link" :class="{'active': mode == 'selected'}" href id="tabLinkEarnings2" role="tab" aria-controls="tabContentEarnings1" :aria-selected="mode == 'selected'" @click.prevent="mode = 'selected'; $bus.$emit('resize')">
                            Selected ({{ selectedEarningsCount }})
                        </a>
                    </li>

                </ul>
            </div>
        </div>

        <div class="flex-body flex-container tab-content earning-selector">
            <div class="flex-body flex-container tab-pane" :class="{'show active': mode == 'all'}" id="tabContentEarnings1" role="tabpanel" aria-labelledby="tabLinkEarnings1">
                <fast-table
                    v-if="mode == 'all'"
                    :sections="earningSections"
                    :headers="earningHeaders"
                    :data="earningTableData"
                    @click="onEarningClick"
                    @select="onEarningSelect"
                    :has-row-select="true"
                    :show-search="!hideSearch"
                    :show-filter="false"
                    :show-more-actions="false"
                    :has-fixed-sort-order="true"
                />

            </div>

            <div class="flex-body flex-container tab-pane" :class="{'show active': mode == 'selected'}" id="tabContentEarnings2" role="tabpanel" aria-labelledby="tabLinkEarnings2">
                <fast-table
                    v-if="mode == 'selected'"
                    :sections="earningSections"
                    :headers="earningHeaders"
                    :data="selectedEarningTableData"
                    @click="onEarningClick"
                    @select="onEarningSelect"
                    :has-row-select="true"
                    :show-search="!hideSearch"
                    :show-filter="false"
                    :show-more-actions="false"
                    :has-fixed-sort-order="true"
                />

            </div>
        </div>
    </div>
    </template>

    <script>
    import FastTable from '@/components/FastTable'

    export default {
        props: ['modelValue', 'selectableEarnings', 'hideSearch', 'hideTabs', 'lockedEarningIds'],
        emits: ['update:modelValue'],
        components: {FastTable, },
        computed: {
            earningTableData() {
                const result = []

                const earnings = [...this.earnings].sort((a, b) => a.sort_priority - b.sort_priority)
                earnings.forEach(c => {
                    const isLocked = this.isLocked(c)
                    const isSelected = this.formData.earnings.includes(c.id) || isLocked
                    const isDisabled = isLocked
                    result.push({
                        id: c.id,
                        isSelected: isSelected,
                        selectDisabled: isDisabled,
                        object: c,
                        cells: [
                            c.name,
                        ],
                    })
                })

                return [result]
            },
            selectedEarningTableData() {
                let result = this.earningTableData[0].filter(row => {
                    return this.formData.earnings.includes(row.object.id) || this.isLocked(row.object)
                })

                result = JSON.parse(JSON.stringify(result))
                result.forEach(row => {
                    row.isSelected = true
                })

                return [result]
            },
            allEarningsCount() {
                return this.earningTableData[0].length
            },
            selectedEarningsCount() {
                return this.selectedEarningTableData[0].length
            },
        },
        data() {
            return {
                mode: 'all',
                earnings: this.selectableEarnings || [],
                formData: {
                    earnings: Array.from(this.modelValue),
                },
                earningSections: [
                    {title: 'All', id: 'all'},
                ],
                earningHeaders: [
                    {label: 'Earning', classes: 'cell-earning', defaultSort: false, isFilterable: false, isSearchable: true, },
                ],
            }
        },
        mounted() {
            this.$bus.$emit('resize')
            if (!this.selectableEarnings) {
                this.getEarnings()
            }
        },
        methods: {
            getEarnings() {
                this.$store.dispatch('START_LOADING')
                this.$api.get('/admin/tax-engine/earning-types').then(resp => {
                    this.earnings = resp
                    this.$store.dispatch('STOP_LOADING')
                }).catch((errors) => {
                    this.$store.dispatch('STOP_LOADING')
                    if (errors.__status__ == 403) {
                        this.$bus.$emit('no-access')
                    }
                    else {
                        this.$bus.showError(errors.__all__)
                    }
                })
            },
            isLocked(earning) {
                // Company earning types carry their global type; global ones are their own
                const globalSlug = earning.earning_type ? earning.earning_type.slug : earning.slug
                return globalSlug == 'regular' || (this.lockedEarningIds || []).includes(earning.id)
            },
            onEarningSelect(rows) {
                const earnings = new Set()
                rows.forEach(row => {
                    if (!(this.lockedEarningIds || []).includes(row.object.id)) {
                        earnings.add(row.object.id)
                    }
                })

                this.formData.earnings = Array.from(earnings)

                this.$emit('update:modelValue', this.formData.earnings)
            },
            onEarningClick(earning) {
                if (this.formData.earnings.includes(earning.id)) {
                    this.formData.earnings = this.formData.earnings.filter(cId => cId != earning.id)
                }
                else {
                    this.formData.earnings.push(earning.id)
                }

                this.$emit('update:modelValue', this.formData.earnings)
            },
        },
    }

    </script>

    <style>
    .earning-selector .table-wrapper {
        min-height: 300px;
    }
    </style>
